module.exports = __webpack_public_path__ + "img/guide16.3de0274a.png";